import { BriefSection } from '@/features/brief/BriefSection';
import { Expertises } from '@/features/expertises/Expertises';
import { HeroJourney } from '@/features/hero/HeroJourney';
import { Crossing } from '@/features/journey/Crossing';
import { Manifesto } from '@/features/manifesto/Manifesto';
import { Method } from '@/features/method/Method';
import { MobileShowcase } from '@/features/mobile/MobileShowcase';

/**
 * Le voyage : chaque chapitre vit près de son trou noir, et l'on passe de l'un
 * à l'autre en le traversant. Le pied de page (l'horizon) clôt le voyage.
 */
export function HomePage() {
  return (
    <>
      <HeroJourney />
      <Crossing to="studio" emergeOnly />
      <Manifesto />
      <Crossing to="expertises" />
      <Expertises />
      <Crossing to="applications" />
      <MobileShowcase />
      <Crossing to="method" />
      <Method />
      <Crossing to="brief" />
      <BriefSection />
      <Crossing to="horizon" />
    </>
  );
}
